import Vue from 'vue'
import platformJs from '@/utils/platform'

Object.defineProperty(Vue.prototype, '$platformJs', { value: platformJs })